import { LineChartProps } from '@mui/x-charts/LineChart/LineChart';
import { LineChart as MuiLineChart } from '@mui/x-charts/LineChart';
import * as React from 'react';

interface Props extends  LineChartProps {
    readonly styled: StyledProps;
}

export class LineChart extends React.PureComponent<Props> {
    render() {
        const { themeMode } = this.props.styled;
        return (
            <MuiLineChart
                {...this.props}
                sx={{
                    '& .MuiResponsiveChart-container': {
                        width: 'calc(100% - 10px)',
                        padding: 5,
                    },
                    '& .MuiChartsAxis-root': {
                        fill: themeMode === 'light' ? '#1a73e8 !important' : '#6ba5ff !important',
                    },
                    '& .MuiChartsAxis-tickLabel': {
                        fill: themeMode === 'light' ? '#1a73e8 !important' : '#6ba5ff !important',
                    },
                    '& .MuiChartsAxis-line': {
                        stroke: themeMode === 'light' ? '#1a73e8 !important' : '#6ba5ff !important',
                    },
                    '& .MuiChartsAxis-tick': {
                        stroke: themeMode === 'light' ? '#1a73e8 !important' : '#6ba5ff !important',
                    },
                    '& .MuiChartsAxis-mark': {
                        stroke: themeMode === 'light' ? '#1a73e8 !important' : '#6ba5ff !important',
                    },
                    '& .MuiChartsLegend-root': {
                        stroke: themeMode === 'light' ? '#1a73e8 !important' : '#6ba5ff !important',
                    },
                    '& .MuiMarkElement-root': {
                        fill: 'none',
                        stroke: 'none',
                    },
                    '& .MuiLineElement-root': {
                        stroke: themeMode === 'light' ? '#1a73e8 !important' : '#6ba5ff !important',
                        strokeWidth: 2,
                    },
                    '& .MuiLineElement-lineHighlight': {
                        stroke: themeMode === 'light' ? '#1a73e8 !important' : '#6ba5ff !important',
                    },
                    ...this.props.sx,
                }}
            />
        );
    }
}